import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const TerminalIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V10.2C1 11.8802 1 12.7202 1.32698 13.362C1.6146 13.9265 2.07354 14.3854 2.63803 14.673C3.27976 15 4.11984 15 5.8 15H10.2C11.8802 15 12.7202 15 13.362 14.673C13.9265 14.3854 14.3854 13.9265 14.673 13.362C15 12.7202 15 11.8802 15 10.2V5.8C15 4.11984 15 3.27976 14.673 2.63803C14.3854 2.07354 13.9265 1.6146 13.362 1.32698C12.7202 1 11.8802 1 10.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803ZM4.15148 7.11652C3.80161 6.89478 3.33824 6.99864 3.11649 7.3485C2.89475 7.69836 2.99861 8.16174 3.34847 8.38348L5.89898 10L3.34847 11.6165C2.99861 11.8383 2.89475 12.3016 3.11649 12.6515C3.33824 13.0014 3.80161 13.1052 4.15148 12.8835L7.70148 10.6335C7.91847 10.496 8.04997 10.2569 8.04997 10C8.04997 9.74309 7.91847 9.50406 7.70148 9.36652L4.15148 7.11652Z"
		/>
	</svg>
))
